




import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ConditionalContent extends Vue {
  // Properties
  @Prop() productIds: number[]
  @Prop({ default: false }) requiresCreditCard: boolean
  @Prop({ default: false }) requiresZeroDollarTotal: boolean

  // Computed Properties
  get isVisible(): boolean {
    // Check to see if cart or order has a zero dollar total depending on the isCheckout property
    if (this.requiresZeroDollarTotal && this.total !== 0) {
      return false
    }

    // Check to see if the checkout requires the user to enter their credit card
    if (this.requiresCreditCard && !this.$store.getters.requiresCreditCard) {
      return false
    }

    // Check to see if the cart or order contains one of the following products from the productIds property
    if (this.productIds?.length > 0 && !this.hasValidProduct) {
      return false
    }

    // Passed all of the checks, display the component
    return true
  }

  get total() {
    return this.$store.getters.finalPaymentAmount ?? this.$store.getters['cart/cart']?.TotalAmount
  }

  get currentProductIds() {
    const personalizationProductIds =
      this.$store.getters.personalization?.Household?.map((m) => m.Reservations?.map((r) => r.ProductId)) ?? []
    const cardProductIds = this.$store.getters['cart/cart']?.Items?.map((i) => i.ProductId) ?? []
    const assignmentProductIds = this.$store.getters.assignmentReservations?.map((r) => r.ProductId) ?? []
    return [...personalizationProductIds, ...cardProductIds, ...assignmentProductIds].reduce(
      (accumulator, value) => accumulator.concat(value),
      []
    )
  }

  get hasValidProduct() {
    return this.productIds?.length > 0 ? this.currentProductIds?.some((r) => this.productIds?.indexOf(r) >= 0) : true
  }
}
